import { VIcon, VSelect, VTextarea } from 'vuetify/lib'
import {account_status, account_types} from '@/views/fin/account_management/fields.js'
import { postEpopAccountUpdateApi, postEpopMonthlyRecordUpdateApi } from '@/views/fin/account_management/services.js'
import { getsafe } from '@/libs/util'
export default {
    props: {
        type:{
            type: String,
        },
        title: {
            type: String,
            default: () => ''
        },
        target: {
            type: Object
        }
    },
    data() {
        return {
            param: null,
        }
    },
    methods: {
        typeComponent() {
            return <VSelect
            label="账户类型"
            item-text="title"
            item-value="key"
            v-model={this.param}
            items={account_types}
        />
        },
        statusComponent() {
            return <VSelect
            label="账户状态"
            item-text="title"
            item-value="key"
            v-model={this.param}
            items={account_status}
        />
        },
        remarkComponent() {
            return <VTextarea
                label="备注"
                rows={4}
                v-model={this.param}
            />
        },
        editModal(key, component, api) {
            this.param = this.target[key]
            
            this.$vModal.confirm({
                    title:'提示',
                    render: component,
                loading:true,
                onOk:({
                    destroy,
                  }) => {
                    api({
                        id:getsafe(this.target, 'id'),
                        [key]:this.param
                    }).then(() => {
                        this.$Message.success('数据保存成功！')
                        this.$emit('success')
                    }).finally(destroy)
               
                  }   
                
            })
        }
    },
    render() {
        return <div style="display:flex;width:100%">
        <div style="flex:1"/>
        <span>{this.title}</span>
        { <VIcon x-small style="cursor: pointer;" on={{
            click: () => {
                switch (this.type) {
                    case 'account_status':
                        this.editModal('account_status', this.statusComponent, postEpopAccountUpdateApi)
                        break;
                    case 'remark':
                        this.editModal('remark', this.remarkComponent, postEpopAccountUpdateApi)
                        break;
                    case 'type':
                        this.editModal('account_type', this.typeComponent, postEpopAccountUpdateApi)
                        break
                    case 'export_remark':
                        this.editModal('remark', this.remarkComponent, postEpopMonthlyRecordUpdateApi)
                        break
                    default:
                        break;
                }
             
            }
            }}>mdi-square-edit-outline</VIcon>}
               <div style="flex:1"/>
</div>
    }
}